import React from "react";
import { withStyles } from "@mui/styles";

import Table from "../../components/table/Table";

const styles = (theme) => ({
  section: {
    width: "100%",
    backgroundColor: "#fff",
  },
});

const headings = [
  {
    label: "Date adjusted",
    key: "dateAdjusted",
    type: "date",
  },
  {
    label: "Event name",
    key: "eventName",
  },
  {
    label: "Event date",
    key: "eventDate",
    type: "date",
  },
  {
    label: "Player name",
    key: "playerName",
  },
  {
    label: "Previous fee",
    key: "previousFee",
    type: "currency",
  },
  {
    label: "New fee",
    key: "newFee",
    type: "currency",
  },
  {
    label: "Adjustment reason",
    key: "adjustmentReason",
  },
];

function ClubReportTable({
  classes,
  eventFeeAdjustmentsReportData,
  addButtonText,
  onAddButtonClick,
  hideSearch,
  onEditFeeCategory,
  onDeleteFeeCategory,
  additionalButtons,
  showDateRangeFilter,
  dateRangeFilterStart,
  onDateRangeFilterStartChange,
  dateRangeFilterEnd,
  onDateRangeFilterEndChange,
  filterSelects,
  showDownloadButton,
  downloadFilename,
}) {
  return (
    <div className={classes.section}>
      <Table
        hideSearch={hideSearch}
        addButtonText={addButtonText}
        headings={headings}
        data={eventFeeAdjustmentsReportData}
        onAddButtonClick={
          onAddButtonClick ? (payload) => onAddButtonClick(payload) : null
        }
        rowActions={[
          {
            type: "edit",
            onClick: onEditFeeCategory
              ? (member) => onEditFeeCategory(member)
              : null,
          },
          {
            type: "delete",
            onClick: onDeleteFeeCategory
              ? (member) => onDeleteFeeCategory(member)
              : null,
          },
        ]}
        additionalButtons={additionalButtons}
        showDateRangeFilter={showDateRangeFilter}
        dateRangeFilterStart={dateRangeFilterStart}
        onDateRangeFilterStartChange={(value) =>
          onDateRangeFilterStartChange(value)
        }
        dateRangeFilterEnd={dateRangeFilterEnd}
        onDateRangeFilterEndChange={(value) =>
          onDateRangeFilterEndChange(value)
        }
        filterSelects={filterSelects}
        showDownloadButton={showDownloadButton}
        downloadFilename={downloadFilename}
      />
    </div>
  );
}

export default withStyles(styles)(ClubReportTable);
